module.exports = __webpack_public_path__ + "static/media/Vera-profil3.a4961004.JPG";